// src/components/AllQuestions/AllQuestions.js

import React, { useState, useEffect } from 'react';
import { fetchQuizData } from '../../services/dataService';
import styles from './AllQuestions.module.css';
import { QUIZ_LISTS } from '../../config/quizLists';

const AllQuestions = () => {
    const [questions, setQuestions] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            let allQuestions = [];
            for (const quizList of QUIZ_LISTS) {
                const data = await fetchQuizData(quizList.id);
                const numberedQuestions = data.map((question, index) => ({
                    ...question,
                    listNumber: quizList.id,
                    listLabel: quizList.label,
                    questionNumber: index + 1
                }));
                allQuestions = [...allQuestions, ...numberedQuestions];
            }
            setQuestions(allQuestions);
        };

        fetchData();
    }, []);

    return (
        <div>
            <h1>Wszystkie pytania</h1>
            <ul>
                {questions.map((question, index) => (
                    <li key={index}>
                        <h2>
                            {question.listLabel
                                ? `${question.listLabel} (${question.listNumber}.${question.questionNumber})`
                                : `${question.listNumber}.${question.questionNumber}`
                            }
                            <br />
                            {question.question}
                        </h2>
                        <ul>
                            {question.answers.map((answer, i) => (
                                <li
                                    key={i}
                                    className={question.correct_answers.includes(i + 1)
                                        ? styles.correctAnswer
                                        : styles.incorrectAnswer}
                                >
                                    {answer}
                                </li>
                            ))}
                        </ul>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default AllQuestions;
